import { S as Swiper } from './swiper-core-ByDrI-gt.js';
import { M as Mousewheel } from './mousewheel-CP1llk_y.js';
import { A as A11y } from './a11y-bPVd604S.js';

class CollectionNavigation extends HTMLElement {
  swiper = this.querySelector('.swiper');

  connectedCallback() {
    this.swiperInstance = new Swiper(this.swiper, {
      modules: [A11y, Mousewheel],
      slidesPerView: 'auto',
      slidesOffsetAfter: -24,
      mousewheel: {
        enabled: true,
        releaseOnEdges: true,
      },
    });
  }
}

customElements.define('collection-navigation', CollectionNavigation);
